import Vue from "vue";
import qs from "qs";

// 埋点数据统一格式化
const formatTrace = value => {
  // 1. 提取埋点数据
  let trace = null;
  if (Array.isArray(value)) {
    trace = { spm: value.join(".") };
  } else if (typeof value !== "object") {
    trace = { spm: value };
  } else {
    trace = { ...value };
  }

  // 2.修正数据
  // 2.1 spm第5位偏移量
  if (trace.index !== undefined && trace.spm) {
    trace.spm = `${trace.spm}.${trace.index}`;
    delete trace.index;
  }

  // 2.2 相对路径改为绝对路径
  if (trace.dest && trace.dest.startsWith('/')) {
    trace.dest = `${window.location.origin}${trace.dest}`;
  }

  return trace;
}

// 点击上报spm
// 传参类型："x.x.x.x" | ["x.x.x.x", index] | { spm: "x.x.x.x", dest: "http://...", index }
Vue.directive("report", {
  inserted(el, binding) {
    try {
      const trace = formatTrace(binding.value);
      el.setAttribute("data-report-click", JSON.stringify(trace));
    } catch (error) {
      console.error("Track click error", error);
    }
  }
});

// 曝光spm
// 传参类型："x.x.x.x" | ["x.x.x.x", index] | { spm: "x.x.x.x", dest: "http://...", index }
Vue.directive("view", {
  inserted(el, binding) {
    try {
      const trace = formatTrace(binding.value);
      el.setAttribute("data-report-view", JSON.stringify(trace));
    } catch (error) {
      console.error("Track view error", error);
    }
  }
});

// 超链接spm透传
// 传参类型："x.x.x.x" | ["x.x.x.x", index] | { spm: "x.x.x.x", dest: "http://...", index }
Vue.directive("query", {
  inserted(el, binding) {
    try {
      const trace = formatTrace(binding.value);
      delete trace.dest;

      el.setAttribute("data-report-query", qs.stringify(trace));
    } catch (error) {
      console.error("Track query error", error);
    }
  }
});

// 全类型埋点
// 传参类型："x.x.x.x" | ["x.x.x.x", index] | { spm: 'x.x.x.x', dest, index, ..., exclude: ['view'] }
// exclude：为不需要的埋点类型，可以为数组或字符串，如 'view' 或 ['view', 'query', 'click']。不传默认3种埋点
Vue.directive("spm", {
  inserted(el, binding) {
    try {
      // 1.提取报告信息
      const trace = formatTrace(binding.value);

      // 2 记录不需要的绑定
      const { exclude = [] } = trace;
      delete trace.exclude;

      // 3.DOM注入
      // 3.1 曝光
      if (!exclude.includes("view")) {
        el.setAttribute("data-report-view", JSON.stringify(trace));
      }
      // 3.2 点击
      if (!exclude.includes("click")) {
        el.setAttribute("data-report-click", JSON.stringify(trace));
      }
      // 3.3 链接。注：非a标签不会使用query
      if (!exclude.includes("query") && el.tagName.toLowerCase() === 'a') {
        delete trace.dest;
        el.setAttribute("data-report-query", qs.stringify(trace));
      }
    } catch (error) {
      console.error("Track error", error);
    }
  }
});
